import React from 'react';
import PendingStockTransferList from './PendingStockTransferList';

const PendingStockTransfer = () => (
  <React.Fragment>
    <div className="org-wrapper">
      <PendingStockTransferList />
    </div>
  </React.Fragment>
);

export default PendingStockTransfer;
